import { Component } from '@angular/core';
import { AWARD_IMAGES, FACILITY_IMAGES, SEMINAR_IMAGES } from 'src/app/data/gallery/gallery.data';

@Component({
  selector: 'app-gallery-page',
  templateUrl: './gallery-page.component.html',
  styleUrls: ['./gallery-page.component.scss']
})
export class GalleryPageComponent {
  selectedImage: string | null = null;

  gallerySections = [
    {
      heading: 'Awards',
      images: AWARD_IMAGES
    },
    {
      heading: 'Services & Seminars',
      images: SEMINAR_IMAGES
    },
    {
      heading: 'Facilities',
      images: FACILITY_IMAGES
    }
  ];

  openImageOverlay(src: string) {
    this.selectedImage = src;
  }

  closeImageOverlay() {
    this.selectedImage = null;
  }

  onImageRightClick(event: MouseEvent) {
    event.preventDefault();
  }
}